import { __assign } from 'tslib';
import MuiChip, { chipClasses } from '@mui/material/Chip';
import { styled, useThemeProps } from '@mui/material/styles';
import React from 'react';

var ChipRoot = styled(MuiChip, {
    shouldForwardProp: function (propName) { return propName !== 'light'; },
})(function (_a) {
    var _b, _c;
    var palette = _a.theme.palette, _d = _a.color, color = _d === void 0 ? 'default' : _d, _e = _a.light, light = _e === void 0 ? false : _e, _f = _a.clickable, clickable = _f === void 0 ? false : _f, _g = _a.variant, variant = _g === void 0 ? 'filled' : _g;
    return (__assign({}, (light &&
        variant === 'filled' && __assign(__assign(__assign(__assign((_b = {}, _b["& .".concat(chipClasses.avatar)] = __assign(__assign({}, (color === 'primary' && {
        color: palette.common.white,
        backgroundColor: palette.primary.main,
    })), ((color === 'secondary' ||
        color === 'error' ||
        color === 'info') && {
        backgroundColor: palette[color].main,
    })), _b["& .".concat(chipClasses.deleteIcon)] = __assign({}, (color !== 'default' &&
        color !== 'info' &&
        color !== 'success' &&
        color !== 'warning' && {
        color: palette[color].main,
        '&:hover, &:active': {
            color: palette[color].dark,
        },
    })), _b), (color !== 'default' &&
        color !== 'info' &&
        color !== 'success' &&
        color !== 'warning' && {
        backgroundColor: palette[color].light,
        color: palette[color].main,
    })), (color === 'secondary' && {
        color: palette.secondary.dark,
    })), ((color === 'info' ||
        color === 'success' ||
        color === 'warning') && {
        backgroundColor: palette[color].light,
    })), (_c = {}, _c["&:hover, &.".concat(chipClasses.focusVisible)] = __assign({}, (clickable &&
        color !== 'default' && {
        backgroundColor: palette[color].semiLight,
    })), _c)))));
});
var Chip = React.forwardRef(function Chip(inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'MuiChip' });
    var clickableProp = props.clickable, onClick = props.onClick;
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    return React.createElement(ChipRoot, __assign({}, __assign(__assign({}, props), { clickable: clickable }), { ref: ref }));
});

export { Chip as default };
